module.exports = __webpack_public_path__ + "static/media/social.19362b57.svg";